// import { Label } from '../Label';
import { CmToFtAndInch } from "../../lengthConvertor";
import { Label } from "../Label";

declare let THREE: any;

export class Size extends Label {
  private static up = new THREE.Vector3(0, 1, 0);
  private static angle = THREE.Math.degToRad(90);

  constructor() {
    super({ width: 80, height: 40 }, { fontSize: 18 });
  }

  update(startPoint, endPoint) {
    const size = startPoint.distanceTo(endPoint);
    super.updateText(CmToFtAndInch(size));

    const direction = endPoint
      .clone()
      .sub(startPoint.clone())
      .normalize();

    const horizontalOffset = direction.clone().multiplyScalar(size / 2);

    // const verticalOffset = direction
    //   .clone()
    //   .applyAxisAngle(Size.up, Size.angle)
    //   .multiplyScalar(this.scale.x / 4);

    this.position.copy(horizontalOffset).add(new THREE.Vector3(0, 100, 0));
    // rotate the size, so it'll be
    // aligned with the arrow
    const rotation = Math.atan2(
      endPoint.x - startPoint.x,
      endPoint.z - startPoint.z
    );
    this.rotation.y =
      rotation > 0 ? rotation - Math.PI / 2 : rotation + Math.PI / 2;
  }

  updateText(text: string) {
    super.updateText(text);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Dimensions/Size.ts